import { render, staticRenderFns } from "./CalendarBody.vue?vue&type=template&id=98dd92ce"
import script from "./CalendarBody.vue?vue&type=script&lang=ts"
export * from "./CalendarBody.vue?vue&type=script&lang=ts"
import style0 from "./CalendarBody.vue?vue&type=style&index=0&id=98dd92ce&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports